// src/hooks/useRouter.js
import { useState, useEffect } from "react";

const ROUTES = {
  "/": "home",
  "/home": "home",
  "/chat": "chat",
  "/aboutus": "about",
  "/contactus": "contact",
  "/business": "business",
  "/news": "news",
  "/settings": "settings",
};

function getRouteFromPath(pathname) {
  // 1. Clean the path string
  const p = pathname.toLowerCase().replace(/\/+$/, "") || "/";

  // 2. CRITICAL FIX: Check for dynamic chat routes
  // If the path starts with "/chat/", we tell the App "This is the chat page"
  if (p.startsWith("/chat/")) {
    return "chat"; 
  }
  // 3. Otherwise, look for exact matches (home, about, etc.)
  return ROUTES[p] || "home";
}

export function useRouter() {
  const [route, setRoute] = useState(getRouteFromPath(window.location.pathname));

  useEffect(() => {
    const onPop = () => setRoute(getRouteFromPath(window.location.pathname));
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  function navigateTo(path) {
    if (window.location.pathname !== path) {
      window.history.pushState({}, "", path);
      setRoute(getRouteFromPath(path));
    }
  }

  return { route, navigateTo, getRouteFromPath };
}